module.exports = __webpack_public_path__ + "static/img/簡單編輯.2ad59e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serviceContent/簡單編輯.jpg
// module id = LeHX
// module chunks = 1